export const authConstants = {
  MonitoringUserNew: "monitoring-user-new",
}